import { useOutlet } from "react-router-dom";
import { UserContextProvider } from "context/UserContext";

export const AuthLayout = () => {
	const outlet = useOutlet();

	return (
		<UserContextProvider>{outlet}</UserContextProvider>
	);
};